// keyBy for array only
export const keyBy = <T>(array: T[], key: keyof T): Record<string, T> =>
  (array || []).reduce((result, currentValue) => {
    const keyValue = key ? String(currentValue[key]) : String(currentValue);
    return { ...result, [keyValue]: currentValue };
  }, {});
